import { lerpColor } from '../../color';
import { hsl, type World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const L = hsl(255, 72, 82);
const A1 = hsl(45, 88, 78);
const A2 = hsl(320, 85, 76);
const RIM = hsl(255, 45, 92);

const world: World = {
  id: 'discoteca',
  name: 'Discoteca',
  seed: 'discoteca',
  legacy: false,
  hue: 255,
  ceil: hsl(255, 28.8, 28),
  font: 'Knewave',
  fontFile: 'knewave-400.woff2',
  fontWeight: '400',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.36,
  fillAlpha: 0.74,
  palette: {
    bg: hsl(255, 36, 10),
    ink: hsl(255, 48, 5),
    rim: RIM,
    held: A1,
    heldShade: hsl(45, 60, 60),
    heldLight: hsl(45, 90, 90),
    incoming: { circle: L, square: A2, triangle: lerpColor(L, A1, 0.5), hex: lerpColor(L, A2, 0.5) },
    spot: A2,
    path: hsl(255, 30, 72),
    text: hsl(255, 40, 94),
    sparks: [A1, A2, L, RIM],
  },
  burst: { count: 12, speed: 0.5, drag: 3.5, gravity: 0.15, spin: 3, life: 1, sizeMin: 0.007, sizeMax: 0.018 },
  dress,
  fx,
  paint,
};

export default world;
